import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertError, AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import fitMemberToPartnerServices from '../../../../../services/fit-member-to-partner.services';
import MemberRequestToPartnerForm from '../form/MemberRequestToPartnerForm';

const MemberRequestToPartnerModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: updateMemberRequestToPartner } =
    fitMemberToPartnerServices.useMutationUpdateMemberRequestToPartner(
      () => {
        queryClient.invalidateQueries({
          queryKey: ['get-member-request-to-partner-request'],
          refetchType: 'all',
        });
        AlertSuccess('แก้ไขข้อมูลสำเร็จ');
        handleClose();
      },
      (err) => {
        AlertError({ text: err });
      }
    );

  const _HandleSubmit = handleSubmit(async (data) => {
    if (watch('formType') === 'edit') {
      updateMemberRequestToPartner({ id: data.id, data });
    }
  });

  return (
    <Modal
      title={watch('formType') === 'create' ? 'อัพเดทสถานะ' : 'อัพเดทสถานะ'}
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <MemberRequestToPartnerForm />
    </Modal>
  );
};

export default MemberRequestToPartnerModal;
